export const EVENT_ACTION_REDEEM_OVERLAY_CLICK =
  'ROO_LOYALTY_REDEEM_OVERLAY_CLICK';
